import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import Amplify from "aws-amplify";
import awsconfig from "./awsconfigExport";

Amplify.configure(awsconfig);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const Login = React.lazy(() => import('./views/login/Login'));
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

class App extends Component {

  async componentDidMount(){
  }
 
  render() {
    return (
      <BrowserRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route path="/(imei|condition|confirm|Confirmlist)/" render={props => <TheLayout {...props} />} />
            <Route path="/" render={props => <Login {...props} />} />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
//export default withAuthenticator(App);